import { Node, mergeAttributes } from '@tiptap/core';
var HardBreak = Node.create({
  name: 'hardBreak',
  addOptions: function addOptions() {
    return {
      keepMarks: true,
      HTMLAttributes: {}
    };
  },
  inline: true,
  group: 'inline',
  selectable: false,
  parseHTML: function parseHTML() {
    return [{
      tag: 'br'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['br', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
  },
  renderText: function renderText() {
    return '\n';
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      setHardBreak: function setHardBreak() {
        return function (_ref2) {
          var commands = _ref2.commands,
              chain = _ref2.chain,
              state = _ref2.state,
              editor = _ref2.editor;
          return commands.first([function () {
            return commands.exitCode();
          }, function () {
            return commands.command(function () {
              var selection = state.selection,
                  storedMarks = state.storedMarks;

              if (selection.$from.parent.type.spec.isolating) {
                return false;
              }

              var keepMarks = _this.options.keepMarks;
              var splittableMarks = editor.extensionManager.splittableMarks;
              var marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
              return chain().insertContent({
                type: _this.name
              }).command(function (_ref3) {
                var tr = _ref3.tr,
                    dispatch = _ref3.dispatch;

                if (dispatch && marks && keepMarks) {
                  var filteredMarks = marks.filter(function (mark) {
                    return splittableMarks.includes(mark.type.name);
                  });
                  tr.ensureMarks(filteredMarks);
                }

                return true;
              }).run();
            });
          }]);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;

    return {
      'Mod-Enter': function ModEnter() {
        return _this2.editor.commands.setHardBreak();
      },
      'Shift-Enter': function ShiftEnter() {
        return _this2.editor.commands.setHardBreak();
      }
    };
  }
});
export { HardBreak, HardBreak as default };